import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { BackendService, NotificationService, ModalService, ApplicationService } from 'beyond-util';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { Subscription } from 'rxjs/Subscription';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pregled-verifikacije',
  templateUrl: './pregled-verifikacije.component.html',
})
export class PregledVerifikacijeComponent extends SifarnikBase implements OnInit {
  public url: SafeResourceUrl;
  private _subscriptions: Subscription[] = [];
  private _abortUrl: string = environment.abortUrl;

  constructor(
    protected _backendService: BackendService,
    protected _notificationService: NotificationService,
    protected _modalService: ModalService,
    private _sanitizer: DomSanitizer,
    private _rtsBackendService: RtsBackendService,
    private _appService: ApplicationService
  ) {
    super(_backendService, _modalService, _notificationService);

    this.url = this.getSantizedURL();
  }

  getSantizedURL() {
    const token = sessionStorage.getItem('token');

    return this._sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.pregledVerifikacijaUrl}?token=${token}`
    );
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    this.sacuvajVerifikaciju();
  }

  getSacuvajPayload() {
    return this._rtsBackendService.getRequestPayload(
      FormCode.MSVER_VER,
      FormName.Verifikacija,
      EndpointTypes.GetAllEntities
    );
  }

  ngOnInit() {
    this._subscriptions.push(
      this._appService.sacuvajKopijuVerifikacije$.subscribe(res => {
        if (res.documentCode === 'PREGLEDVERIFIKACIJE') {
          this.sacuvajVerifikaciju();
        }
      })
    );
  }

  sacuvajVerifikaciju() {
    const payload: any = this.getSacuvajPayload();
    payload.token = sessionStorage.getItem('token');

    const payloadString = JSON.stringify(payload);
    navigator.sendBeacon(this._abortUrl, payloadString);

    this._subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-verifikacije/pregled-verifikacije.component.ts